import ProgramCard from '@/components/cards/ProgramCard';
import Container from '@/components/container/Container';
import { X4bUserRoleEnum } from '@/constants/roles';
import routes from '@/constants/routes';
import { useAuthenticationStore } from '@/store';
import { useNavigate } from 'react-router-dom';

type Programs = {
	image: string;
	title: string;
	description: string;
	active: boolean;
};

type ProgramsList = {
	programsList: Array<Programs>;
};

const TabContent = ({ programsList }: ProgramsList) => {
	const navigate1 = useNavigate();
	const isManager = useAuthenticationStore((state) => state.hasRoles)([X4bUserRoleEnum.Manager]);

	const navigate = () => {
		navigate1(routes['/programs/id']);
	};
	return (
		<Container className="grid grid-cols-1 md:grid-cols-2 gap-4">
			{programsList.map((item: Programs) => (
				<Container className="flex cursor-pointer" key={item.title}>
					<ProgramCard
						imageUrl={item.image}
						title={item.title}
						description={item.description}
						checked={item.active}
						setChecked={() => {
							if (!isManager) return;
							// later on...
						}}
						onClick={() => {
							if (!isManager) return;
							navigate()
						}
						}
					/>
				</Container>
			))}
		</Container>
	);
};

export default TabContent;
